import React from 'react';
import backgroundImg from '../../assets/images/bg-fhe9vnw.jpg';

const backgroundImageStyle = {
    backgroundImage: 'url(' + backgroundImg + ')'
};

function M4(props){
    const extraContent = props.data.extraContent.extraContent.split('\n').map((item, i) => {
        return <p className="c0_content" key={i}>{item}</p>;
    });

    const grid = [];

    props.data.contentText.forEach((item)=>{
        grid.push(
            <div className="m4_grid_item c2 -variant-2" key={item.id}>
                <figure className="c2_figure">
                    <a href={item.ctaLink} title={item.ctaText}>
                        <img className="c2_figure_image"
                             src={item.image.file.url}
                             title={item.image.title}
                             alt={item.image.description}
                        />
                    </a>
                </figure>
                <a href={item.ctaLink} title={item.ctaText} className="c2_cta">{item.ctaText}</a>
            </div>
        );
    });

    return <section className="m4" style={backgroundImageStyle}>
        <div className="m4_columns container">
            <div className="m4_column c0">
                <h1 className="c0_headline">{props.data.title}</h1>
                {extraContent}
            </div>
            <div className="m4_column m4_grid">
                {grid}
            </div>
        </div>
    </section>;
}

export default M4;
